import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Is need for some libraries that expect a global variable (like AWS Amplify)
(window as any).global = window;

// Load Amplify configuration to initialize AWS Amplify services
import './app/core/config/amplify-config';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
